export const ISSUE_REPORT_NOTE_MAX_LENGTH = 500;

export const ISSUE_REPORT_REASONS = [
  { value: 'image_word_mismatch', label: 'Image does not match the word' },
  { value: 'image_unclear', label: 'Image is unclear or too ambiguous' },
  { value: 'image_broken', label: 'Image failed to load or is broken' },
  { value: 'word_problem', label: 'Word looks incorrect or too obscure' },
  { value: 'inappropriate_content', label: 'Image is inappropriate' },
  { value: 'other', label: 'Other issue' },
];

